<template>
  <div class="position-relative">
    <div class="modal fade" role="dialog" id="moreModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ title }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div v-html="moreText"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :ref="'ellipsis' + this.random"
      :class="{ 'ellipsis-2-lines': showMore }"
    >
      <div v-html="moreText"></div>
    </div>
    <a class="text-primary show-more" v-if="showMore" data-target="#moreModal" data-toggle="modal">
      ...更多
    </a>
  </div>
</template>
<script>
export default {
  name: 'More',
  props: {
    moreText: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 63
    },
    title: {
      type: String,
      default: '可用門市'
    }
  },
  computed: {
    left () {
      const width = this.$refs['ellipsis' + this.random].scrollWidth
      return `left:${width}px`
    }
  },
  data () {
    return {
      showMore: false,
      random: 0,
      showBenefits: false,
      benefitText: ''
    }
  },
  mounted () {
    this.showMoreBtn()
  },
  methods: {
    showMoreBtn () {
      this.random = Math.floor(Math.random() * 10000)
      this.$nextTick(() => {
        if (
          Number(this.$refs['ellipsis' + this.random].scrollHeight) >
          this.height
        ) {
          this.showMore = true
        } else {
          this.showMore = false
        }
      })
    }
  },
  watch: {
    moreText () {
      this.showMoreBtn()
    }
  }
}
</script>

<style lang="scss" scoped>
.ellipsis-2-lines{
  overflow:hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipsis-2-lines {
  -webkit-line-clamp: 2;
}
.show-more {
  cursor: pointer;
  position: absolute;
  background-color: white;
  padding: 0px 2px;
  bottom: -1px;
  right: 0px;
}
.table-striped>tbody>tr:nth-of-type(odd) .show-more {
  background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// More.vue?29020497